Shopware.Component.register('riccardo-advisor-list', () => import('./page/riccardo-advisor-list'));
Shopware.Component.register('riccardo-advisor-detail', () => import('./page/riccardo-advisor-detail'));

Shopware.Module.register('riccardo-advisor', {
    type: 'plugin',
    name: 'riccardo-advisor',
    title: 'Berater',
    description: 'Aromenberater und Geräteberater',
    color: '#E30613',
    icon: 'regular-lightbulb',
    entity: 'riccardo_advisor_question',

    routes: {
        list: { component: 'riccardo-advisor-list', path: 'list' },
        detail: { component: 'riccardo-advisor-detail', path: 'detail/:id', meta: { parentPath: 'riccardo.advisor.list' }, props: { default: (route) => ({ questionId: route.params.id }) } },
        create: { component: 'riccardo-advisor-detail', path: 'create/:flow', meta: { parentPath: 'riccardo.advisor.list' }, props: { default: (route) => ({ flow: route.params.flow }) } },
    },

    navigation: [{
        id: 'riccardo-advisor',
        label: 'Berater',
        color: '#E30613',
        path: 'riccardo.advisor.list',
        icon: 'regular-lightbulb',
        parent: 'sw-content',
        position: 95,
    }],
});
